// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Kl70","sendOtp":"AuthorizeToLogin_sendOtp__2j6mv"};